import axiosInstance from './axiosInstance';

// Obtener todas las rutas
export const fetchRoutes = async () => {
    const response = await axiosInstance.get('/rutas');
    return response.data;
};

// Obtener una ruta por ID
export const fetchRouteById = async (id) => {
    const response = await axiosInstance.get(`/rutas/${id}`);
    return response.data;
};

// Crear nueva ruta
export const createRoute = async (data) => {
    const response = await axiosInstance.post('/rutas', data);
    return response.data;
};

// Actualizar ruta
export const updateRoute = async (id, data) => {
    const response = await axiosInstance.put(`/rutas/${id}`, data);
    return response.data;
};

// Eliminar (lógicamente) una ruta
export const deleteRoute = async (id) => {
    const response = await axiosInstance.delete(`/rutas/${id}`);
    return response.data;
};
